import {
    SET_VARIANT_ANSWERS
} from '../actions/actionTypes';

const initialState = {};


function answersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_VARIANT_ANSWERS:
      return {
        ...state,
        ...action.payload
      };
    
    default:
      return state;
  }
}

export default answersReducer;